<template lang="pug">
form(v-on:submit.prevent)
  .modal-card(style="width: auto")
    .modal-card-head
      .modal-card-title {{verbGerund}} {{noun}}
    .modal-card-body
      .field
        .label Voucher Code
        .control
          input(class="input" placeholder="Voucher Code" ref="focus" v-bind:class="[$v.name.$error ? 'is-danger' : 'is-success']" v-bind:value="$v.name.$model" v-on:input="$v.name.$model = $event.target.value.toUpperCase()" v-on:keypress.13.prevent)
        .help(class="is-danger" v-show="$v.name.$error && !$v.name.required") Voucher code is required
        .help(class="is-danger" v-show="$v.name.$error && !$v.name.validName") Invalid voucher code
    .modal-card-foot
      button(class="button has-text-weight-semibold" v-on:click="$parent.close()") Close
      button(class="button has-text-weight-semibold is-primary" v-bind:disabled="$v.$invalid" v-on:click="$parent.close(); impl(name)") {{verbBase}} {{noun}}
</template>

<script>
import { helpers, required } from 'vuelidate/lib/validators'

import ApiMixin from '@/mixins/ApiMixin.vue'

const validName = (name, vm) => !helpers.req(name) || vm.apiVouchers.find((voucher) => voucher.name === name) !== undefined

export default {
  mixins: [
    ApiMixin
  ],
  props: {
    impl: {
      required: true,
      type: Function
    },
    initialName: {
      required: true,
      type: String
    },
    noun: {
      required: true,
      type: String
    },
    verbBase: {
      required: true,
      type: String
    },
    verbGerund: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      name: this.initialName,
      vouchers: []
    }
  },
  async created () {
    await this.initialiseEnterVoucherCodeForm()
  },
  mounted () {
    this.$refs.focus.focus()
  },
  methods: {
    async initialiseEnterVoucherCodeForm () {
      await this.apiGetVouchers()
    }
  },
  validations: {
    name: {
      required,
      validName
    }
  }
}
</script>
